import { analyticsTrackEvent } from '../../utils/analytics';
import { MATERIALS_DELETE_FOLDER } from '../../constants/analytics';
import { DeleteFolderContract } from '@ublend-npm/aula-schema/types/materials';
import { CLASSROOM_MATERIAL_FOLDER } from '../../constants/endpoints';
import request from './request';

const deleteFolder = async (
  classRoomId: string,
  folderId: string,
  correlationId?: string,
  educatorOnly?: boolean,
  isRbacEnabled: boolean = false
) => {
  const url = CLASSROOM_MATERIAL_FOLDER(classRoomId, folderId, educatorOnly);
  const response = await request<DeleteFolderContract>({
    method: 'delete',
    url,
  });
  if (response.status === 204) {
    try {
      analyticsTrackEvent(MATERIALS_DELETE_FOLDER, {
        itemId: folderId,
        spaceId: classRoomId,
        itemType: 'Material',
        isRbacEnabled,
      });
    } catch {
      // Analytics must not turn a successful API request into a failed action.
    }
  }
  return response.status === 204;
};

export default deleteFolder;
